import { fetchGraphQL } from '../Connections';


export function getOrganizationPaymentTypesByFacilityUid(variables) {
  // TODO: Update settings column to `payment_types` after migration
  const query = `query getOrganizationSettingsByFacilityUid($facility_uid: String!) {
    getOrganizationSettingsByFacilityUid(facility_uid: $facility_uid) {
      id,
      settings {
        payment_types
      }
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function getOrganizationInvoiceNotesByFacilityUid(variables) {
  const query = `query getOrganizationSettingsByFacilityUid($facility_uid: String!) {
    getOrganizationSettingsByFacilityUid(facility_uid: $facility_uid) {
      id,
      settings {
        invoice_notes
      }
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function getOrganizationPaymentTypes(variables) {
  const query = `query getOrganizationPaymentTypes($organizationId: Int!) {
    getOrganizationPaymentTypes(organizationId: $organizationId) {
      paymentTypes {
        id,
        paymentTypeName
      }
    }
  }`

  return fetchGraphQL({ query, variables });
}
